import React from 'react'
import { Form as FinalForm } from 'react-final-form'
import PropTypes from 'prop-types'

import { validate } from '@models/organization'
import { RailsForm } from '@support/RailsForm'
import Form from './Form'
import httpService from '@services/httpService'

const timezone_browser = Intl.DateTimeFormat().resolvedOptions().timeZone

const onlyDigits = (value) => (value ? String(value).replace(/\D/g, '') : value)

// Campos contratuais legados (flat, jsonb registration_data) que o form não
// edita mais — agora vivem em cada item de contracts.
const LEGACY_CONTRACT_KEYS = [
  'legal_name', 'tax_id', 'contract_code', 'contract_type', 'contract_period_months',
  'renewal_date', 'shipping_street', 'shipping_city', 'shipping_state', 'shipping_zip_code',
  'billing_same_as_shipping', 'billing_street', 'billing_city', 'billing_state', 'billing_zip_code'
]

const handleSubmit = async (values, handleError, o) => {
  const organization = {
    ...values,
    timezone_user: timezone_browser,
    customer_success_manager_id: values.customer_success_manager ? values.customer_success_manager.value : null,
    contracts: (values.contracts || []).map(contract => ({
      ...contract,
      tax_id: onlyDigits(contract.tax_id),
      shipping_zip_code: onlyDigits(contract.shipping_zip_code),
      billing_zip_code: onlyDigits(contract.billing_zip_code)
    }))
  }

  LEGACY_CONTRACT_KEYS.forEach(key => delete organization[key])

  try {
    const { data } = await httpService.post(`/v4/o/${o}/admin/organizations`, organization)

    Turbolinks.visit(`/v4/o/${o}/admin/organizations/${data.id}`)
  }
  catch (error) {
    handleError(error)
  }
}

export const New = ({ model, organization_kinds, predominant_cultures, customer_success_managers, tenants, status_options, contract_types, global_admin, handleError, o }) => (
  <RailsForm
    component={FinalForm}
    action='create'
    url={`/v4/o/${o}/admin/organizations`}
    validate={validate}
    initialValues={{ contracts: [{ billing_same_as_shipping: false }] }}
    handleSubmit={(values) => handleSubmit(values, handleError, o)}
    render={(props) => (
      <Form
        {...props}
        title={I18n.t('v4/organization.actions.add')}
        organizationKinds={organization_kinds}
        predominantCultures={predominant_cultures}
        customerSuccessManagers={customer_success_managers}
        tenants={tenants}
        statusOptions={status_options}
        contractTypes={contract_types}
        globalAdmin={global_admin}
        o={o}
        timezone_user={timezone_browser}
      />
    )}
  />
)

New.propTypes = {
  model: PropTypes.object,
  organization_kinds: PropTypes.array,
  predominant_cultures: PropTypes.array,
  customer_success_managers: PropTypes.array,
  tenants: PropTypes.array,
  status_options: PropTypes.array,
  contract_types: PropTypes.array,
  global_admin: PropTypes.bool,
  handleError: PropTypes.func,
  o: PropTypes.string
}

export default New
